import {useEffect, useState} from 'react'
import {BooksitoutServer} from '../../../../config/BooksitoutServer'
import DayOfWeekPatternResponse from '../responses/DayOfWeekPatternResponse'

const useDayOfWeekPattern = () => {
	const [data, setData] = useState<DayOfWeekPatternResponse | null>(null)
	const [isLoading, setIsLoading] = useState<boolean>(true)

	useEffect(() => {
		BooksitoutServer
			.get(`/v1/statistics/day-of-week-pattern`)
			.then(res => setData(res.data))
			.finally(() => setIsLoading(false))
	}, [])

	return [data, isLoading] as const
}

export default useDayOfWeekPattern
